import classNames from 'classnames';
import React from 'react';
export var TxButtonMode;
(function (TxButtonMode) {
    TxButtonMode["Primary"] = "primary";
    TxButtonMode["Secondary"] = "secondary";
    TxButtonMode["Tertiary"] = "tertiary";
    TxButtonMode["Danger"] = "danger";
})(TxButtonMode || (TxButtonMode = {}));
export function TxButton({ mode = TxButtonMode.Primary, children, className, ...props }) {
    return (React.createElement("button", { ...props, className: classNames('tx-btn', 'tx-btn--' + mode, className) }, children));
}
//# sourceMappingURL=Button.js.map